"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
const computePrice_1 = require("../computePrice");
const computeOrderArrival_1 = require("../computeOrderArrival");
/**
 * Set status of order to IN_PROGRESS
 * Can only be done when the order is in CREATED status
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    let order = (0, utils_1.clone)(prevState);
    if (prevState.status === domain_1.OrderStatus.CREATED) {
        (0, utils_1.updateOrderAndItemsStatus)(order, domain_1.OrderStatus.IN_PROGRESS, domain_1.OrderItemStatus.IN_PROGRESS);
        // This step is specific to doshii, because of their legacy system.
        // They move pending status to complete (for pre-paid order) on accept itself.
        // [Note] Skipping it for Oolio Store as payments are received by merchants directly.
        if (Array.isArray(order.payments) &&
            order.payments.length > 0 &&
            order.source !== domain_1.App.OOLIO_STORE) {
            let isPaymentUpdated = false;
            order.payments = order.payments.map(payment => {
                if (payment.status === domain_1.OrderPaymentStatus.PENDING) {
                    payment.status = domain_1.OrderPaymentStatus.COMPLETE;
                    isPaymentUpdated = true;
                }
                return payment;
            });
            if (isPaymentUpdated) {
                order = { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
            }
        }
        if (order.requiredAt) {
            // requiredAt and DueAt
            order.dueAt = (0, computeOrderArrival_1.calculateDueAt)(order.requiredAt, order.prepTime || 0, 0, event.timestamp);
        }
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=acceptOrder.js.map